<template>
  <v-dialog v-model="isShow" max-width="350">
      <v-card>
        <v-card-title class="headline">Alterar Imagem</v-card-title>
        <v-card-text>
            <vue-croppie 
              ref="croppieRef" 
              :enableOrientation="true"
              :viewport="{ width: 200, height: 200, type: 'square' }"
              :boundary="{ width: 250, height: 250}"
              :enableResize="false"
              @result="result"
              @update="update"
              >
              <!--
                v-if="dataUrl"
              @result="result"
              @update="update" -->
            </vue-croppie>
            <form action="">
                <input type="file" 
                name="pic" 
                accept="image/*"
                @change="imageUploaded"   
                class='btn btn-default'
                style="width:300px;">
            </form>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click.native="$emit('modalClose')">Cancelar</v-btn>
          <v-btn color="green darken-1" flat="flat" @click.native="cropImage">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>

export default {
  components: {},
  data () {
    return {
      croppie: null,
      image: null,
      dataUrl: null
    }
  },
  watch: {
    isShow (val) {
      this.$emit('modalClose')
    }
  },
  props: {
    isShow: false
  },
  methods: {
    cropImage () {
      let self = this
      this.$refs.croppieRef
        .result({
          type: 'base64',
          format: 'jpeg'
        })
        .then(function (image) {
          self.$emit('imageCropped', image)
        })
    },
    imageUploaded (e) {
      var image = e.target.files[0]
      console.log(image)
      this.imgPreview(image)
    },
    imgPreview (file) {
      let self = this

      if (!file || !window.FileReader) return

      if (/^image/.test(file.type)) {
        var reader = new FileReader()
        reader.readAsDataURL(file)

        reader.onloadend = function () {
          self.dataUrl = this.result
          self.$refs.croppieRef.bind({
            url: self.dataUrl
          })
        }
      }
    }
  },
  mounted () {
  },
  beforeDestroy () {
  }
}
</script>


// WEBPACK FOOTER //
// src/components/reusable/ChangeImage.vue